import { Component, OnInit, Input } from "@angular/core";
import { General, Catalogo } from '../../interfaces/general';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
import { debounceTime } from 'rxjs/operators';
import { referenciasFamiliares, referenciasPersonales } from '../../interfaces/solicitudes';
import { Store } from '@ngrx/store';
import * as SolicitudesActions from '../../ngrx/solicitudes.action'

@Component({
	selector: "app-referencias-personales",
	templateUrl: "./referencias-personales.component.html",
	styleUrls: ["./referencias-personales.component.css"],
})
export class ReferenciasPersonalesComponent implements OnInit {
	@Input() catalogos: General
	@Input() estadosCiviles: Array<Catalogo>
	@Input() parentescos: Array<Catalogo>
	tipoPersona = 6;
	extranjeroEs = false
	pais:string
	@Input() estados: Array<any>
	paises : any
	municipios: any;
	curps: any = [];
	referencias: any = [];
	referenciasPersonales: FormGroup;

	get Referencias(): FormArray {
		return this.referenciasPersonales.get('ListaReferenciasPersonales') as FormArray
	}

	constructor(private formBuilder: FormBuilder,
		private serviciosGenerales: ServiciosGeneralesService,
		private store: Store<referenciasPersonales>) {
		this.crearFormulario();
	}

	ngOnInit(): void {
		this.actualizarStore();
	}

	crearFormulario() {
		this.referenciasPersonales = this.formBuilder.group({
			ListaReferenciasPersonales: this.formBuilder.array([
				this.listaReferenciasPersonales()
			])
		})
	}

	listaReferenciasPersonales(): FormGroup {
		let referencia = this.formBuilder.group({
			SolicitantePersona_ParentescoID: ['',Validators.required],
			Direccion: this.formBuilder.group({
				Direcciones_EntidadFederativaID: ['', Validators.required],
				Direcciones_MunicipioID: ['',Validators.required],
				Direcciones_LocalidadID: ['',Validators.required],
				Direcciones_CodigoPostal: ['',Validators.required],
				Direcciones_ColoniaID: ['',Validators.required],
				Direcciones_CalleID: ['',Validators.required],
				Direcciones_AsentamientoID: ['',Validators.required],
				Direcciones_CarreteraID: ['',Validators.required],
				Direcciones_CaminoID: ['',Validators.required],
				Direcciones_NoExterior: ['',Validators.required],
				Direcciones_NoInterior: ['',Validators.required],
				Direcciones_Calle: ['',Validators.required],
			}),
			DatosContacto_TelefonoFijo: ['',Validators.required],
			DatosContacto_TelefonoCelular: ['',Validators.required],
			Personas_CURP: ['', Validators.required],
			Personas_Nombre: ['', Validators.required],
			Personas_ApellidoPaterno: ['', Validators.required],
			Personas_ApellidoMaterno: ['', Validators.required],
			Personas_EntidadFederativaID: ['', Validators.required],
			Personas_MunicipioID: ['', Validators.required],
			Personas_PaisID: ['',''],
			Personas_EstadoCivilID: ['', Validators.required],
		})

		referencia.valueChanges.pipe(
      debounceTime(1500)
    ).subscribe(referencia =>
			this.obtenerdatosCURP(referencia.Personas_CURP))
    return referencia
	}
	removerReferencia(i) {
		this.Referencias.removeAt(i);
	}
	agregarReferencia() {
		this.Referencias.push(this.listaReferenciasPersonales());
	}

	obtenerdatosCURP(CURP: string) {
		this.actualizarStore()
		this.serviciosGenerales.obtenerDatosCURP(CURP).subscribe((res) => {
			this.curps.push(res.Data)
					if(res.Data.Country === "MEX") {
						this.extranjeroEs = false;
					} else {
						this.pais = res.Data.Country
						this.extranjeroEs = true;
						this.obtenerPaises();
					}
		})
	}


	obtenerPaises ():void {
		this.serviciosGenerales.listadoPaises().subscribe(res => {
			this.paises = res
			const pais = this.paises.filter(pais => pais.ISO_A3 === this.pais)
			this.referenciasPersonales.controls.ListaReferenciasPersonales.get('Personas_PaisID').setValue(pais.ID);
		});
	}

	listarMunicipios(idEstado?:number) {
		this.serviciosGenerales.listadoMunicipios(idEstado).subscribe((res) => {
			console.log('respusta municipios', res);
			this.municipios = res
		})
	}

	mostrarInformacion(referencia) {
		this.referencias = []
		referencia.forEach((element, i) => {
			this.referencias.push({
				Personas_CURP: element.Curp,
				Personas_Nombre: element.Name,
				Personas_ApellidoPaterno: element.Lastname,
				Personas_ApellidoMaterno: element.Surname,
				Personas_EntidadFederativaID: +element.StateId,
				Personas_MunicipioID: +element.CityId,
				Personas_EstadoCivilID: '',
				SolicitantePersona_ParentezcoID: ''
			});
			this.store.dispatch(SolicitudesActions.refFamiliares(this.referencias))
		});
		this.referenciasPersonales.controls['ListaReferenciasPersonales'] =
		this.formBuilder.array(this.referencias.map(i => this.formBuilder.group(i)))
	}

	actualizarStore() {
		this.referenciasPersonales.valueChanges.pipe(
      debounceTime(1500)
    ).subscribe(referencia => {
				this.store.dispatch(SolicitudesActions.refPersonales({referenciasPersonales: referencia.ListaReferenciasPersonales}))
		})
	}

}
